export default __webpack_public_path__ + "static/media/no_appointment.37c6dc2a.svg";